var map = {
	"./1-g.png": "8864",
	"./10-g.png": "1297",
	"./2-g.png": "2490",
	"./3-g.png": "caa9",
	"./4-g.png": "9008",
	"./5-g.png": "bd5f",
	"./6-g.png": "9d2e",
	"./7-g.png": "89bc",
	"./8-g.png": "f249",
	"./9-g.png": "5169"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7afd";